import React, {createContext, PropsWithChildren, useContext, useMemo} from "react";
import {notification} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {PALETTE} from "./palette";
import {showBrowserNotification} from "./helper";
import {NotifyProps, NType} from "./interface";
import LocaleString from "../localization/LocaleString";
import LocaleStringWrapped from "../localization/LocaleStringWrapped"; // ⬅️ yeni
import "./style.scss";
import {wrapText} from "../../../helpers/stringHelper";

type NotifyFn = (opts: NotifyProps) => Promise<void>;
const Ctx = createContext<NotifyFn | null>(null);

export const MinoNotificationProvider = ({ children }: PropsWithChildren) => {
    const [api, holder] = notification.useNotification();

    const notify = useMemo<NotifyFn>(() => {
        return async (props: NotifyProps) => {
            const type: NType = props.type ?? "success";
            const palette = PALETTE[type];
            const maxWidth = props.maxWidth ?? 560;

            const baseTitle =
                props.title ?? (type === "error" ? "Bilinmeyen Hata" : "İşlem Başarılı...");
            const baseMessage = props.message ?? "...";

            if (props.showBrowserNotification) {
                showBrowserNotification(baseTitle, baseMessage);
            }

            const i18nOn = !(props.i18n?.notTranslate === true);
            const maxLineWidth = props.maxLineWidth ?? 60;

            api.open({
                key: props.key,
                className: `mino-notification mino-${type}`,
                icon: null,
                duration: props.duration ?? 4.5,
                closeIcon: <CloseOutlined style={{ color: "rgba(0,0,0,.45)" }} />,
                message: (
                    <div className="mino-head">
                        <span className="mino-icon-badge" aria-hidden>{palette.icon}</span>
                        <span className="mino-title" aria-live="polite">
              {props.i18n?.notTranslate || props.i18n?.notTranslateTitle ? (
                  baseTitle
              ) : (
                  <LocaleString value={baseTitle} formatValue={props.i18n?.formatValue} />
              )}
            </span>
                    </div>
                ),
                description: (
                    <div className="mino-desc">
                        {i18nOn && !props.i18n?.notTranslateMessage ? (
                            <LocaleStringWrapped
                                value={baseMessage}
                                formatValue={props.i18n?.formatValue}
                                maxLineWidth={maxLineWidth}
                            />
                        ) : (
                            // ⬇️ ÇEVİRİ yoksa mevcut wrapText ile
                            <>
                                {(baseMessage.includes("\r\n")
                                        ? baseMessage.split("\r\n")
                                        : wrapText(baseMessage, maxLineWidth)
                                ).map((segment, i) => (
                                    <p key={i} className="mino-line">{segment}</p>
                                ))}
                            </>
                        )}
                    </div>
                ),
                style: { maxWidth },
                placement: props.placement ?? "top",
            });
        };
    }, [api]);

    return (
        <Ctx.Provider value={notify}>
            {holder}
            {children}
        </Ctx.Provider>
    );
};

export const useMinoNotification = () => {
    const ctx = useContext(Ctx);
    if (!ctx) throw new Error("useMinoNotification must be used within MinoNotificationProvider");
    return ctx;
};
